export default function PaymentManagement() {

  return (
      <p>مدیریت پرداخت‌ها</p>
  );
};